import React, {PureComponent} from 'react';
import * as environment from '../../../modules/environment';
import {Col, Button, Row, Card, CardBody} from 'reactstrap';
import * as http from '../../../modules/http';
import TextSearch from '../../../components/TextSearch'
import LoadingProgress from '../../../components/LoadingProgress';
import {
    tasks_update_field,
    tasks_insert,
    tasks_update, fetchTasksCount
} from '../../../redux/actions/TasksActions';
import Alert from '../../../components/Alert';
import {ButtonToolbar} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";
//import RadioButton from '../../../modules/RadioButton'
//import MultiSelect from '../../../components/form/MultiSelect'
import Select from '../../../components/Select'

class EditTasksForm extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            comment: ''
        };
    }

    componentDidMount() {
    }

    formFieldValueChanged = (type, value) => {
        this.props.dispatch(tasks_update_field(type, value));
    };

    saveTask = () => {

        const isAdding = (this.props.taskInEdit.id === 0);
        //validation
        if (isAdding) {
            if (!this.props.taskInEdit.name || this.props.taskInEdit.name === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }

            /*if(!this.props.taskInEdit.storeId || this.props.taskInEdit.storeId === '' || this.props.taskInEdit.storeId === 0) {
                this.setState({warning: 'שדה שם חנות הוא חובה'});
                return;
            }*/

            /*if(!this.props.taskInEdit.managerId || this.props.taskInEdit.managerId === '' || this.props.taskInEdit.managerId === 0) {
                this.setState({warning: 'שדה נציג מטפל הוא חובה'});
                return;
            }*/

            if(!this.props.taskInEdit.task || this.props.taskInEdit.task === '') {
                this.setState({warning: 'שדה המשימה הוא חובה'});
                return;
            }

            /*if(!this.props.taskInEdit.comment || this.props.taskInEdit.comment === '') {
                this.setState({warning: 'שדה הערות הוא חובה'});
                return;
            }*/

            this.setState({warning: ''});
        }

        this.setState({saving: true, error: false});

        var taskData = {
            id: this.props.taskInEdit.id,
            date: this.props.taskInEdit.date,
            provider: this.props.taskInEdit.provider,
            task: this.props.taskInEdit.task,
            name: this.props.taskInEdit.name,
            storeId: this.props.taskInEdit.storeId,
            managerId: this.props.taskInEdit.managerId,
            comment: this.props.taskInEdit.comment,
            status: this.props.taskInEdit.status
        };

        var requestUrl = 'tasks/update';
        if (isAdding) {
            requestUrl = 'tasks/new';
        }
        http.postToServer(
            requestUrl,
            taskData,
            (response) => {

                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(tasks_insert(response.data[0]));
                }
                else {
                    this.props.dispatch(tasks_update(response.data[0]));
                }

                this.props.dispatch(fetchTasksCount());

                this.props.onClose();

            },
            (response) => {
                console.log('error storing');
                this.setState({saving: false, error: true})
            }
        );
    };

    render() {

        const isAdding = this.props.taskInEdit.id === 0;

        let providers = [];
        //let stores = [];
        //let managers = [];

        const statusArr = [{label: TextManager.getCurrentTextResource().Text.new, value: 1},
            {label: TextManager.getCurrentTextResource().Text.active, value: 2},
            {label: TextManager.getCurrentTextResource().Text.inactive, value: 3}];

        if(this.props.utilsData && this.props.utilsData.data &&
            this.props.utilsData.data.providers && this.props.utilsData.data.stores && this.props.utilsData.data.managers) {
            providers = this.props.utilsData.data.providers;
            //stores = this.props.utilsData.data.stores;
            //managers = this.props.utilsData.data.managers.map( m => { return {label: m.name, value: m.id}});
        }

        //console.log(this.props.taskInEdit);

        return (

            <Row style={{flexDirection: "row-reverse"}}>
                <Col md={7}>
                    <Card>
                        <CardBody>
                            <div className='card__title'>
                                <h5 className='bold-text'>{isAdding ? 'Add Task' : 'Edit Task'}</h5>
                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>חברה סלולרית</label>
                                    <div className='form__form-group-field'>
                                        <Select value={this.props.taskInEdit.provider}
                                                onChange={(e) => this.formFieldValueChanged('provider', e.value)}
                                                select
                                                options={providers}>
                                        </Select>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>המשימה (פירוט במילים)</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.taskInEdit.task}
                                                    onChange={(value) => this.formFieldValueChanged('task', value)}/>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>שם לקוח</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.taskInEdit.name}
                                                    onChange={(value) => this.formFieldValueChanged('name', value)}/>
                                    </div>
                                </div>

                                {/*<div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>שם חנות</label>
                                    <div className='form__form-group-field'>
                                        <Select value={this.props.taskInEdit.storeId}
                                                onChange={(e) => this.formFieldValueChanged('storeId', e.value)}
                                                select
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>נציג מטפל</label>
                                    <div className='form__form-group-field'>
                                        <Select value={this.props.taskInEdit.managerId}
                                                onChange={(e) => this.formFieldValueChanged('managerId', e.value)}
                                                select
                                                options={managers}>
                                        </Select>
                                    </div>
                                </div>

                                <div className="form__form-group">
                                    <label
                                        className='form__form-group-label'>הערות</label>
                                    <div className='form__form-group-field'>
                                        <textarea
                                            //style={{backgroundColor: '#DCDCDC'}}
                                            value={this.props.taskInEdit.comment}
                                            name="comment"
                                            onChange={(e) => this.formFieldValueChanged('comment', e.target.value)}
                                        />
                                    </div>
                                </div>*/}

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>סטטוס</label>
                                    <div className='form__form-group-field'>
                                        <Select value={this.props.taskInEdit.status}
                                                onChange={(e) => this.formFieldValueChanged('status', e.value)}
                                                select
                                                options={statusArr}>
                                        </Select>
                                    </div>
                                </div>

                                <span style={{display: "inline-block", height: 40}}></span>

                            </form>

                            {this.state.error &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Utils.error}</span>
                                    </p>
                                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                </Alert>
                            </Row>
                            }

                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Utils.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>
                            }

                            {!this.state.saving &&
                            <ButtonToolbar className="form__button-toolbar">
                                <Button color="primary"
                                        onClick={this.saveTask}>{isAdding ? TextManager.getCurrentTextResource().Sales.salesItem.send : TextManager.getCurrentTextResource().Sales.salesItem.update}</Button>
                                {this.props.onClose && <Button type="button" onClick={this.props.onClose}>
                                    {TextManager.getCurrentTextResource().Text.cancel}
                                </Button>}

                                {!this.props.onClose &&
                                <Button type="button" onClick={() => this.setState({saved: true})}>
                                    {TextManager.getCurrentTextResource().Text.cancel}

                                </Button>}
                            </ButtonToolbar>
                            }
                            {
                                this.state.saving &&
                                <LoadingProgress/>
                            }
                        </CardBody>
                    </Card>
                </Col>
                {/*<Col>
                    <DropFiles customHeight
                               multi={false}
                               files={this.state.files[0]}
                               onChange={(files) => this.selectCreative(files)}
                    />
                </Col>*/}
            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        taskInEdit: state.tasks.taskInEdit,
        userData: state.userData,
        utilsData: state.utilsData,
    };
};

export default withRouter(connect(mapStateToProps)(EditTasksForm))